import { AuthContext } from '@repo-level/core-front';
import useEventListener from '@repo-level/core-front/hooks/eventListener';
import { AnalyticsEventName } from 'api/analytics';
import { Logo } from 'components/Logo';
import { AddonsContext } from 'contexts/addons';
import { useAnalytics } from 'helpers/analytics';
import { useMedia } from 'modules/common/hooks/useMedia';
import { useContext, useMemo, useRef, useState } from 'react';
import { useCurrentRoute } from 'react-navi';
import { UserWallets } from '../UserWallets';
import { ScMobileHeader } from './styled';

const noHeaderPages = ['search-games'];

export const HeaderMobile = () => {
  const {
    url: { pathname },
  } = useCurrentRoute();

  const { isEmailConfirmationPopup, emailConfirmationPopupHeight } =
    useContext(AddonsContext);

  const ref = useRef<HTMLDivElement | null>(null);
  const [isTop, setIsTop] = useState(true);

  const { sendEventToAnalytics } = useAnalytics();

  const { isMobile } = useMedia();
  const { isAuthenticated } = useContext(AuthContext);

  const noHeader = useMemo(
    () => noHeaderPages.includes(pathname.split('/')[1]),
    [pathname]
  );

  useEventListener('scroll', () => setIsTop(window.scrollY <= 20));

  const {
    sendLogoButtonAnalytics,
    sendCurrencySelectAnalytics,
    sendDepositButtonAnalytics,
  } = useMemo(
    () => ({
      sendLogoButtonAnalytics: () =>
        sendEventToAnalytics({
          name: AnalyticsEventName.HEADER__LOGO__CLICK,
        }),
      sendCurrencySelectAnalytics: () =>
        sendEventToAnalytics({
          name: AnalyticsEventName.HEADER__CURRENCY_SELECT__CLICK,
        }),
      sendDepositButtonAnalytics: () =>
        sendEventToAnalytics({
          name: AnalyticsEventName.HEADER__DEPOSIT_BUTTON__CLICK,
        }),
    }),
    [sendEventToAnalytics]
  );

  return !isMobile || noHeader ? null : (
    <ScMobileHeader
      emailConfirmationPopupHeight={emailConfirmationPopupHeight}
      isAuth={isAuthenticated}
      isTop={isTop}
      ref={ref}
      withEmailConfirmationPopup={isEmailConfirmationPopup}
    >
      <Logo
        height={isAuthenticated ? 24 : 32}
        onClick={sendLogoButtonAnalytics}
        smallLogo={isAuthenticated}
      />
      {isAuthenticated && (
        <div className="wallet">
          <UserWallets
            onClickCurrencySelectButton={sendCurrencySelectAnalytics}
            onClickDepositButton={sendDepositButtonAnalytics}
          />
        </div>
      )}
    </ScMobileHeader>
  );
};
